export const moduleId = '1f24 e53a';
